import React from 'react';
import { useNavigate } from 'react-router-dom';
import { StyleSheet, View } from './components/base_components';

import { BusyOverlay, useBusy } from './components/busy_component';
import StandardScreen from './components/standard_screen';
import TextButton from './components/buttons/text_button';
import TitleActionLine from './components/title_action_line';
import BoxPropList from './components/box_prop_list';

import UserStore from './stores/user_store';

const styles = StyleSheet.create({
  accountScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
});

export default function AccountScreen() {
  const [is_busy, setBusy, clearBusy] = useBusy();
  const user = UserStore.useUser();
  const [updates, setUpdates] = React.useState<any>({});
  const navigate = useNavigate();

  function _onSave(complete) {
    const { user_name } = updates;
    if (user_name && setBusy()) {
      UserStore.updateUser(updates, (err) => {
        clearBusy();
        if (err === 409) {
          window.alert('Username already in use.');
        } else if (err === 400) {
          window.alert(
            'Invalid username, please only use letters, numbers, dash and underscore.  Usernames must be between 4 and 32 characters.'
          );
        } else if (err) {
          window.alert('Save failed, please try again.');
        } else {
          complete();
        }
      });
    }
  }
  function _onLogoutPress() {
    const yes = window.confirm('Are you sure you want to logout?');
    if (yes && setBusy()) {
      navigate('/');
      UserStore.logout(() => {
        clearBusy();
      });
    }
  }

  return (
    <View style={styles.accountScreen}>
      <StandardScreen>
        <TitleActionLine title='Account'>
          <TextButton text='Sign out' onPress={_onLogoutPress} />
        </TitleActionLine>
        <BoxPropList
          title='Your User'
          editable={true}
          updates={updates}
          onChange={setUpdates}
          onSave={_onSave}
          columns={[
            [
              {
                key: 'user_name',
                label: 'User Name',
                value: user?.user_name,
                emptyValue: '-',
                input: {
                  placeholder: 'user name',
                },
              },
              {
                label: 'Email Address',
                value: user?.email,
              },
            ],
          ]}
        />
      </StandardScreen>
      <BusyOverlay isBusy={is_busy} />
    </View>
  );
}
